import { Button, FormControlLabel, Switch, Typography, alpha, styled } from "@mui/material";
import React from "react";

import { m, motion } from "framer-motion";

import CarouselItem from "./Carouseltem";

export const palette = {
  primaryText: "#eb0a1e",
  white: "#FFFFFF",
  backgroundPaper: "#212B36",
  backgroundNeutral: alpha("#919EAB", 0.16),
};
interface InteractionGuideProps {
  className?: string;
  isActive: boolean;
  headline?: string;
  buttonText?: string;
  switchLabel?: string;
  handleClose?: () => void;
  handleSwichtChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isMotionLazyLoad?: boolean;
}

const variants = {
  visible: {
    display: "block",
    opacity: 1,
    scale: 1,
    backdropFilter: "blur(5px)",
    transition: { type: "spring", stiffness: 100, delay: 0.5 },
  },
  hidden: {
    display: "none",
    opacity: 0,
    scale: 0.8,
    backdropFilter: "blur(5px)",
    transition: { type: "spring", stiffness: 100 },
  },
};

export default function InteractionGuide({
  isActive,
  className,
  headline,
  buttonText,
  switchLabel,
  handleClose,
  handleSwichtChange,
  isMotionLazyLoad = false,
}: InteractionGuideProps) {
  const framer = isMotionLazyLoad ? m : motion;

  const visibility = isActive ? "visible" : "hidden";

  return (
    <framer.div className={className} initial="hidden" animate={visibility} variants={variants}>
      <CarouselBox>
        {headline && (
          <Typography variant="subtitle2" textTransform="uppercase" align="center" sx={{ mt: 2 }}>
            {headline}
          </Typography>
        )}
        <CarouselItem item={{ title: "Move", description: "Move Left and Right" }} />
        {buttonText && (
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              textTransform: "none",
              mx: "15px",
              mb: "15px",
              color: palette.white,
              backgroundColor: alpha("#919EAB", 0.08),
              "&:hover": {
                backgroundColor: alpha("#919EAB", 0.24),
              },
            }}
          >
            {buttonText}
          </Button>
        )}
        {switchLabel && (
          <FormControlLabel
            sx={{
              mx: "15px",
              mb: "15px",
              ".MuiFormControlLabel-label": {
                fontSize: "0.9rem",
              },
            }}
            control={<Switch onChange={handleSwichtChange} name="hideGuide" color="secondary" />}
            label={switchLabel}
          />
        )}
      </CarouselBox>
    </framer.div>
  );
}

const CarouselBox = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  width: "225px",
  backgroundColor: alpha(palette.backgroundNeutral, 0.6),
  color: palette.white,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
}));
